/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {InjectionToken} from '@angular/core';
import {MenuProvider} from "./helpers/menu-provider.interface";

export const MENU_PROVIDERS = new InjectionToken<MenuProvider[]>('MENU_PROVIDERS');
